import React from "react";
//var PropTypes = require('prop-types');

function GridMenu(props) {
  return <div>Grid menu boxes</div>;
}

export default GridMenu;
